module.exports = __webpack_public_path__ + "static/img/cajamitras.18b25ee1.jpg";